/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponseModel, DateRangeQuery } from 'types/common'
import axiosInstance from './axios'
import {
  GiftTransactionRequestModel,
  TemAccumumationRequestModel,
  CustomerModel,
  CustomerRequestModel,
  TemAccumumationModel,
  GiftTransactionModel,
} from 'types/customers'

const handleResult = (response: ApiResponseModel<any>) => {
  if (!response || !response.Result || response.ErrorCode !== 0) return null
  if (Array.isArray(response.Result) && response.Result.length) {
    return response.Result[0]
  }

  return response.Result
}

const customerApis = {
  getCustomer: async (payload: CustomerRequestModel) => {
    const res = await axiosInstance.post<any, ApiResponseModel<any>>(
      '/customerdetail',
      payload
    )

    const result = handleResult(res)

    return {
      ...res,
      Result: result,
    } as ApiResponseModel<CustomerModel>
  },
  getTemAccumulation: async (params: TemAccumumationRequestModel) => {
    const res = await axiosInstance.get<any, ApiResponseModel<Array<any>>>(
      'gettemtransaction',
      {
        params,
      }
    )
    return handleResult(res) as Array<TemAccumumationModel>
  },

  giftTransactions: async (params: GiftTransactionRequestModel) => {
    const res = await axiosInstance.get<any, ApiResponseModel<Array<any>>>(
      'getgifttransaction',
      {
        params,
      }
    )

    return handleResult(res) as Array<GiftTransactionModel>
  },

  exportReport: (phoneNumber: string) =>
    axiosInstance.post<any, ApiResponseModel<string>>('ExportExcelByCustomer', {
      phoneNumber,
    }),

  exportAllReport: (dateRange: DateRangeQuery) =>
    axiosInstance.post<any, ApiResponseModel<string>>(
      'ExportExcelByAll',
      dateRange
    ),
}

export default customerApis
